import { useCallback, useEffect, useRef } from 'react';

import { useForceUpdate } from '../../util/useForceUpdate';
import { useFavoriteChannels } from '../favorite/useFavoriteChannels';

export function useFavoriteChannelWithInitial() {
  const initialFavoriteChannels = useRef<Map<number, number> | null>(null);

  const { favoriteChannels, refetch: refetchFavorite, isRefetching } = useFavoriteChannels({});
  const forceUpdate = useForceUpdate();

  const refetch = useCallback(() => {
    initialFavoriteChannels.current = null;

    refetchFavorite();
  }, [refetchFavorite]);

  const reorder = useCallback(() => {
    if (!favoriteChannels) return;

    initialFavoriteChannels.current = favoriteChannels;

    forceUpdate();
  }, [favoriteChannels, forceUpdate]);

  useEffect(() => {
    if (favoriteChannels && !initialFavoriteChannels.current && !isRefetching) {
      initialFavoriteChannels.current = favoriteChannels;
    }
  }, [favoriteChannels, isRefetching]);

  return {
    reorder,
    favoriteChannels,
    refetch,
    isRefetching,
    initialFavoriteChannels: initialFavoriteChannels.current || favoriteChannels,
  };
}
